import { render, staticRenderFns } from "./GroupAdminAddNew.vue?vue&type=template&id=0b886740&scoped=true"
import script from "./GroupAdminAddNew.vue?vue&type=script&lang=js"
export * from "./GroupAdminAddNew.vue?vue&type=script&lang=js"
import style0 from "./GroupAdminAddNew.vue?vue&type=style&index=0&id=0b886740&prod&scoped=true&lang=css"
import style1 from "./GroupAdminAddNew.vue?vue&type=style&index=1&id=0b886740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b886740",
  null
  
)

export default component.exports